import {
    VIEW_ONCHANGE
} from '../Actions/ProductListView.action';

const DEFAULT_STATE = {
    viewstatus:0
};

export const productListView = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case VIEW_ONCHANGE:
            localStorage.setItem("productviewstatus", payload.value);
            return {                
                viewstatus:payload.value,
            };
        default:
            return state;
    }
};
